package com.ives.modules.cine;

import js.html.TouchEvent;
import js.html.WheelEvent;

import haxe.Timer;

import com.ives.components.workspace.DicomWorkspace;
import com.ives.components.viewer.DicomViewer;
import com.ives.utils.Config;
import com.ives.utils.Log;

class Cine extends Module{
	static private inline var DEFAULT_DELAY_MS = 50; // 20 FPS

	static public inline var CINE_MODULE:String = "CINE_MODULE";
	static public inline var CINE_PLAY:String = "CINE_PLAY";
	static public inline var CINE_STOP:String = "CINE_STOP";
	static public inline var CINE_PREV:String = "CINE_PREV";
	static public inline var CINE_NEXT:String = "CINE_NEXT";
	static public inline var CINE_SKIP:String = "CINE_SKIP";

	private var index:Int = -1;
	private var playing:Bool = false;
	private var firstLoad:Bool = true;
	private var delay:UInt;
	private var lastTouchX:Float;

	override public function init(dicomViewer:DicomViewer, ?dicomWorkspace:DicomWorkspace){
		super.init(dicomViewer, dicomWorkspace);

		if(getWorkspaceMode() != DicomViewer.WORKSPACE_NORMAL)
			return;

		Log.debug('Init! ${getWorkspaceMode()}');

		dicomWorkspace.on("wheel", onMouseWheel);
	}

	private function initCine(){
		if(total() > 1)
			dicomViewer.showBottomBar();

		skipTo(Std.int(dicomWorkspace.dicomImageData.childIds.length / 2) + dicomWorkspace.id);
	}

	private function total():Int{
		var total:Int = dicomWorkspace.dicomImageData.childIds.length;

		if(dicomWorkspace.dicomImageData.numberOfFrames > 1)
			total = dicomWorkspace.dicomImageData.numberOfFrames;

		return total;
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(getWorkspaceMode() != DicomViewer.WORKSPACE_NORMAL)
			return;

		if(event.type == CINE_MODULE)
			initCine();

		if(event.type == CINE_PLAY)
			play();

		if(event.type == CINE_STOP)
			stop();

		if(event.type == CINE_NEXT)
			next();

		if(event.type == CINE_PREV)
			prev();

		if(event.type == CINE_SKIP)
			skipHandler(event.data[0]);
	}

	private function onMouseWheel(event:WheelEvent){
		if(!event.ctrlKey)
			onWheel(event.deltaY);
	}

	private function onWheel(delta:Float){
		delta < 0 ? next() : prev();
	}

	private function play(){
		if(total() <= 1 || playing)
			return;

		playing = true;

		delay = Std.int(1000/dicomWorkspace.dicomImageData.recommendedDisplayFrameRate);

		if(delay < DEFAULT_DELAY_MS)
			delay = DEFAULT_DELAY_MS;

		Log.debug('Delay set at ${delay}, default delay at ${DEFAULT_DELAY_MS}');

		playFrame();
	}

	private function stop(){
		playing = false;
	}

	private function playFrame(){
		if(!playing)
			return;

		next();

		Timer.delay(playFrame, delay);
	}

	private function next(){
		skipTo(index + 1);
	}

	private function prev(){
		skipTo(index - 1);
	}

	private function skipTo(index:Int){
		var total:Int = total();

		if(index >= total)
			index = index % total;

		while(index < 0)
			index += total;

		if(total > 1 || index == 0)
			dispatchEvent(new ModuleEvent(CINE_SKIP, [index, total], workspaceIdForEvent(), false, true));
	}

	private function skipHandler(index:Int){
		if(dicomWorkspace.dicomImageData.photometricInterpretation.length < 1)
			return;

		Log.debug('Skipping to {index}');

		var total:Int = total();

		if(index >= total)
			index = index % total;

		while(index < 0)
			index += total;

		if(this.index == index)
			return;

		this.index = index;

		dicomWorkspace.sliceValue.innerHTML = '${index+1}/${total}';

		dicomWorkspace.index = this.index;

		dicomWorkspace.dicomImage.setBaseUrl('${Config.SERVER_URL}/dicom/${dicomWorkspace.dicomImageData.sourceName}/context/${dicomWorkspace.dicomImageData.id}/slice/${index}');
	}

	private function onTouchStart(event:TouchEvent){
		lastTouchX = event.touches.item(0).pageX;
	}

	private function onTouchMove(event:TouchEvent){
		var delta:Float = event.touches.item(0).pageX - lastTouchX;

		if(Math.abs(delta) < 5)
			return;

		onWheel(delta);

		lastTouchX = event.touches.item(0).pageX;
	}
}
